import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//components
import { Container } from '@/components/Grid/Container';
import { Section } from '@/components/Grid/Section';
import { Feature, FeatureGroup, FeatureIcon } from '@/components/Feature';

import {
  StyledFeatureTitle,
  StyledFeatureDescription,
  StyledImages,
} from './ImageGridSection.styles';

const Principle = styled(Feature)`
  box-sizing: border-box;
  margin: 0 0 24px;

  &:nth-child(4) {
    margin: 0;
  }

  ${screen.md} {
    align-items: flex-start;
    width: 50% !important;
    margin: 0 0 50px;
    padding: 0 11px;

    &:nth-child(3),
    :nth-child(4) {
      margin: 0;
    }
  }

  ${screen.lg} {
    padding: 0 9px;

    &:nth-child(3),
    :nth-child(4) {
      margin: 0;
    }
  }

  ${screen.xxlg} {
    margin: 0 0 72px;
    padding: 0 10px;

    &:nth-child(3),
    :nth-child(4) {
      margin: 0;
    }
  }
`;

export const ImageGridSection = () => (
  <Section>
    <Container>
      <FeatureGroup>
        <Principle>
          <StyledFeatureTitle>Chicago</StyledFeatureTitle>
          <StyledFeatureDescription>
            Loadsmart was founded in New York and is headquartered in Chicago,
            IL. Our teams operate remotely from different parts of the United
            States as well as in several locations across Latin America.
          </StyledFeatureDescription>
          <FeatureIcon>
            <StyledImages
              width="670"
              height="381"
              src={`/images/careers/offices/chicago.jpg`}
              alt="Chicago area"
            />
          </FeatureIcon>
        </Principle>
        <Principle>
          <StyledFeatureTitle>Phoenix</StyledFeatureTitle>
          <StyledFeatureDescription>
            Located in the Grand Canyon state, our Arizona office gives our AZ
            Loadies a place to collaborate over coffee or vibe on the roof at
            then end of the day.
          </StyledFeatureDescription>
          <FeatureIcon>
            <StyledImages
              width="670"
              height="381"
              src={`/images/careers/offices/phoenix.jpg`}
              alt="Phoenix area"
            />
          </FeatureIcon>
        </Principle>
        <Principle>
          <StyledFeatureTitle>New York</StyledFeatureTitle>
          <StyledFeatureDescription>
            With an empire state of mind, Loadsmart began its humble start in
            the big apple. With a small team of scrappy tech minded logistics
            pros ready to disrupt the industry.
          </StyledFeatureDescription>
          <FeatureIcon>
            <StyledImages
              width="670"
              height="381"
              src={`/images/careers/offices/newyork.jpg`}
              alt="New York area"
            />
          </FeatureIcon>
        </Principle>
        <Principle>
          <StyledFeatureTitle>Worldwide</StyledFeatureTitle>
          <StyledFeatureDescription>
            With Loadies all over the world we continue to grow our global
            presence of logistics professionals.
          </StyledFeatureDescription>
          <FeatureIcon>
            <StyledImages
              width="670"
              height="381"
              src={`/images/careers/offices/worldwide.jpg`}
              alt="Countries flags"
            />
          </FeatureIcon>
        </Principle>
      </FeatureGroup>
    </Container>
  </Section>
);
